import React from 'react';
import caseStudy from "../../../assets/images/caseStudy.png";
import XCircle from "../../../assets/images/XCircle.png";

const GdRandomlySelected = ({ name, onClose, glmMode }) => {
  return (
    <div
      className="absolute z-[999] bottom-[1%] mx-[4%]"
    >
      <div
        className="bg-blue-500 bg-opacity-50 px-[4%] pb-0 rounded-t-lg rounded-b-none self-start"
      >
        <img
          src={caseStudy}
          alt="Case Study"
          className="object-contain"
          style={{ height: '8%', width: '8%' }}
        />
      </div>
      <div
        className="w-[92%] bg-blue-500 bg-opacity-50 px-[4%] py-[3%] rounded-b-lg rounded-tl-none flex flex-row items-center"
      >
        {glmMode === 'leader_system_select' && (
          <span className="text-white flex-1 text-base" style={{ fontFamily: "'Lato', sans-serif" }}>
            Viliyo has randomly selected {name} as your Group Leader!
          </span>
        )}
        {glmMode === 'leader_each_select' && (
          <span className="text-white flex-1 text-base" style={{ fontFamily: "'Lato', sans-serif" }}>
            You have nominated and selected {name} as your Group Leader!
          </span>
        )}
        {glmMode === 'leader_trainer_select' && (
          <span className="text-white flex-1 text-base" style={{ fontFamily: "'Lato', sans-serif" }}>
            Trainer has selected {name} as your Group Leader!
          </span>
        )}
        <button onClick={onClose}>
          <img
            src={XCircle}
            alt="Close"
            className="object-contain"
            style={{ height: '8%', width: '8%' }}
          />
        </button>
      </div>
    </div>
  );
};

export default GdRandomlySelected;